// hooks/useWebSocket.js
import {useEffect, useState, useCallback, useRef} from 'react';
import {websocketApi} from '../api/websocket';

export const useWebSocket = (path = '') => {
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(null);
  const messageQueue = useRef([]);
  const messageListenerRef = useRef(null);

  // Обработчик входящих сообщений
  const handleMessage = useCallback((message) => {
    setMessages(message);
  }, []);

  // Обработчик состояния подключения
  const checkConnection = useCallback(() => {
    const connected = websocketApi.isConnected();
    setIsConnected(connected);

    // При восстановлении соединения отправляем сообщения из очереди
    if (connected && messageQueue.current.length > 0) {
      messageQueue.current.forEach((msg) => websocketApi.send(msg));
      messageQueue.current = [];
    }
  }, []);

  // Функция для отправки сообщений
  const send = useCallback(
    (message) => {
      if (isConnected) {
        websocketApi.send(message);
      } else {
        messageQueue.current.push(message);
        setError(new Error('Сообщение добавлено в очередь. Нет соединения.'));
      }
    },
    [isConnected]
  );

  // Подключение WebSocket и подписка на сообщения
  useEffect(() => {
    // Подключаемся к WebSocket
    websocketApi.connect(path);

    // Подписываемся на сообщения
    messageListenerRef.current = websocketApi.subscribe(handleMessage);

    // Проверяем соединение каждую секунду
    const connectionInterval = setInterval(checkConnection, 1000);

    return () => {
      // Отписываемся от сообщений
      if (messageListenerRef.current) {
        messageListenerRef.current();
      }

      // Очищаем интервал проверки соединения
      clearInterval(connectionInterval);
    };
  }, [path, handleMessage, checkConnection]);

  // Очистка при размонтировании
  useEffect(() => {
    return () => {
      setMessages([]);
      messageQueue.current = [];
    };
  }, []);

  return {
    messages,
    send,
    isConnected,
    error,
    clearMessages: () => setMessages([]),
    clearError: () => setError(null),
    reconnect: () => {
      websocketApi.disconnect();
      websocketApi.connect(path);
    },
  };
};
